import { Button } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const AddRemoveButton = withStyles(Button, {
  root: {
    width: "100%",
    height: "56px",
    backgroundColor: "#F7F9FB",
    borderRadius: 0,
    color: "#7b8496",
    border: "1px solid #EDF0F5",
    "&:hover": {
      backgroundColor: "#F7F9FBaa",
    },
  },
  label: {
    color: colors.dark,
  },
});

export default AddRemoveButton;
